import React, { useState, useEffect, useContext } from "react";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import MainTitle from "../common/MainTitle";
import MainButton from "../common/MainButton";
import ListStats from "../common/ListStats";
import ClassResultList from "./ClassesResultList";

import { YearContext } from "../../contexts/yearContext";
import MainPrintLink from "../common/MainPrint";

import * as XLSX from 'xlsx-js-style';
import _ from "lodash";

const ClassResult = (props) => {
  const { entryYear } = useContext(YearContext);

  const [data, setData] = useState([]);
  const { fid, cid } = props.match.params;

  useEffect(async () => {
    const ac = new AbortController();
    requestData({ entry_year_id: entryYear });
    return () => ac.abort();
  }, [entryYear]);

  const requestData = async (p = new Object()) => {
    try {
      const { entry_year_id } = p;

      let query = `results/${fid}/${cid}?`;

      if (entry_year_id) query += `&entryYearId=${entry_year_id}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };


  const handleExportToExcel = async () => {
    console.log('exporting to excel. ')

    let data = {};
    let subjects = {};
    let class_info = {};
    let students = []


    // getting data from api
    await db.getAll(`results/resultBook/${cid}`).then(({data: apiData}) => {
      data = apiData
      class_info = data?.summary?.class_info;

      students = _.orderBy(data.data || [], ["subjects_summary.percentage",], ["desc"]);

      var semester_subjects = {};

      for (let student of apiData.data) {
        for (let subject of student.subjects[0]) {
          var old_students = semester_subjects[subject.subject_name]?.students || [];
          var final_total = subject.final_total;
          semester_subjects[subject.subject_name] = {
            subject,
            "students": [...old_students, {...student, final_total}]
          };
        }
      }

      subjects = semester_subjects;
    });


    // create a new workbook object
    const workbook = XLSX.utils.book_new();

    // add a new worksheet to the workbook
    const worksheet = XLSX.utils.aoa_to_sheet([]);

    // helper function to insert a cell
    function insertCell(value, style={}, mergeCols) {
      // get the current cell address
      let defaultStyle = {
        alignment: {horizontal: 'center', vertical: 'center'},
      }

      let address = XLSX.utils.decode_cell(currentCell);
      let endAddress = {...address};

      // merge cells if specified
      if (mergeCols) {
        endAddress.c += mergeCols;
        worksheet['!merges'] = worksheet['!merges'] || [];
        worksheet['!merges'].push({s: {r: address.r, c: address.c}, e: {r: endAddress.r, c: endAddress.c}});
      }

      // set the value of the cell
      XLSX.utils.sheet_add_aoa(worksheet, [[value]], { origin: address });

      if (worksheet[currentCell]) worksheet[currentCell].s = {...defaultStyle, ...style};

      // move to the next column
      endAddress.c += 1;
      currentCell = XLSX.utils.encode_cell(endAddress);
    }


    // helper function to move to the next row
    function nextRow(numOfSteps = 1, startFromBeginning = true) {
      // get the current cell address
      let address = XLSX.utils.decode_cell(currentCell);
      // move to the next row
      address.r += numOfSteps;

      if (startFromBeginning) address.c = 0;

      currentCell = XLSX.utils.encode_cell(address);
    }


    // helper function to move to the next row
    function nextColumn(numOfSteps = 1, startFromBeginning = true) {
      // get the current cell address
      let address = XLSX.utils.decode_cell(currentCell);
      // move to the next row
      address.c += numOfSteps;

      if (startFromBeginning) address.r = 0;

      currentCell = XLSX.utils.encode_cell(address);
    }

    function getResult(result) {
      let res = 'نامعلوم'

      if (result === 0) res = 'ناکام';
      else if (result === 1) res = 'کامیاب';
      else if (result === 2) res = 'محروم';

      return res
    }

    const headerStyle = {
      font: { bold: true },
    };

    const subjectCount = Object.keys(subjects).length;
    const totalColumns = 12 + subjectCount;


    let currentCell = 'A1';

    nextRow();
    nextColumn(6, false);
    insertCell('وزارت تحصیلات عالی افغانستان', headerStyle, subjectCount - 1)
    nextColumn(4, false);
    insertCell('خلص نتایج', headerStyle, 1)
    nextRow();

    nextColumn(6, false);
    insertCell('پوهنتون آریا', headerStyle, subjectCount - 1)
    nextColumn(4, false);
    insertCell('تعداد داخله');
    insertCell(class_info?.total_count);
    nextRow();

    nextColumn(6, false);
    insertCell('معاونیت امور محصلان', headerStyle, subjectCount - 1)
    nextColumn(4, false);
    insertCell('شامل امتحان');
    insertCell(class_info?.total_allowed);
    nextRow();

    nextColumn(6, false);
    insertCell(class_info?.faculty, headerStyle, subjectCount - 1)
    nextColumn(4, false);
    insertCell('کامیاب');
    insertCell(class_info?.total_passed);
    nextRow();

    nextColumn(6, false);
    insertCell(` جدول نتایج ${class_info?.class_desc} (${class_info?.entry_year})  ${class_info?.time} `, headerStyle, subjectCount - 1)
    nextColumn(4, false);
    insertCell('اخطاریه');
    insertCell(class_info?.total_warnings);
    nextRow();

    nextColumn(totalColumns - 2, false);
    insertCell('ناتکمیل');
    insertCell(class_info?.total_unfinished);
    nextRow();

    nextColumn(totalColumns - 2, false);
    insertCell('شمولیت مجدد');
    insertCell(class_info?.total_rejoined);
    nextRow();

    nextColumn(totalColumns - 2, false);
    insertCell('ناکام ');
    insertCell(class_info?.total_failed);
    nextRow();

    nextColumn(totalColumns - 2, false);
    insertCell('محروم');
    insertCell(class_info?.total_deprived);
    nextRow();

    nextColumn(totalColumns - 2, false);
    insertCell('تبدیلی');
    insertCell(class_info?.total_swapped);
    nextRow(2);


    insertCell('مشخصات', headerStyle, 5);
    Object.keys(subjects).map(subject =>  insertCell(subject, headerStyle))
    insertCell('نتیجه نهایی', headerStyle, 5);

    nextRow();

    insertCell('شماره', headerStyle);
    insertCell('کد دانشجو', headerStyle);
    insertCell('شماره تذکره', headerStyle);
    insertCell('نام', headerStyle);
    insertCell('نام پدر', headerStyle);
    insertCell('نام پدرکلان', headerStyle);
    Object.keys(subjects).map(s =>  insertCell(subjects[s].subject?.credits, headerStyle));
    insertCell('تعداد کردیت', headerStyle);
    insertCell('مجموع', headerStyle);
    insertCell('معدل', headerStyle);
    insertCell('GPA', headerStyle);
    insertCell('نتیجه', headerStyle);
    insertCell('ملاحظات', headerStyle);

    nextRow();

    let counter = 1;
    for (let student of students) {
      insertCell(counter++)
      insertCell(student.aria_id)
      insertCell(student.tazkera_no)
      insertCell(student.student_name)
      insertCell(student.student_father_name)
      insertCell(student.grand_father_name)

      for (let subject of Object.keys(subjects)){
        let final = null;
        let students = subjects[subject].students

        for (let currentStudent of students) {
          if (currentStudent.student_id === student.student_id) {
            final = currentStudent.final_total
            break;
          }
        }


        let warningStyle = final !=null && final < 55 ? { fill: { fgColor: { rgb: "FFFFAA00" } } } : {}
        insertCell(final ?? '', warningStyle);
      }

      insertCell(student?.subjects_summary?.credits)
      insertCell(student?.subjects_summary?.total)
      insertCell(student?.subjects_summary?.percentage)
      insertCell(student?.subjects_summary?.GPA)
      insertCell(getResult(student?.subjects_summary?.result))
      insertCell(student?.subjects_summary?.remark)

      nextRow()
    }


    // add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'results');

    // save the workbook as an Excel file
    XLSX.writeFile(workbook, `class_${cid}_resultBook_summary.xlsx`);

  }

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainButton title={lbl.PrevPage} type={"back"} />
          <MainTitle title={data?.summary?.title} />
        </div>
        <div className="left-content">
          <MainPrintLink path={`results/class-result-book/${cid}`} title={'چاپ کتاب نتایج'} />
          <MainPrintLink path={`results/class-result-summary/${cid}`} title={'چاپ خلاصه نتایج'} />
          <MainButton title={lbl.Excel} type={"excel"} handleClick={handleExportToExcel}/>
        </div>
      </div>
      <div className="main-content-body">
        <ListStats stats={data.summary} />
        <ClassResultList data={data.data} {...props} />
      </div>
      <div className="">
        <div className="route-history-area"></div>
      </div>
    </div>
  );
};

export default ClassResult;
